import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgArrowDownLeftArrowUpRight = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <mask
      id='arrow-down-left-arrow-up-right_svg__a'
      width={22}
      height={22}
      x={1}
      y={1}
      maskUnits='userSpaceOnUse'
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill={props.color}
        d='M9.399 12.674a.94.94 0 0 1 .72.299c.422.422.422 1.02 0 1.45a1.12 1.12 0 0 1-.756.299l-6.337.079c-.615.017-1.09-.457-1.08-1.081l.079-6.337c0-.273.114-.571.298-.756.431-.422 1.029-.422 1.45 0 .203.202.308.44.3.712l-.053 2.909-.088 1.213 1.186-1.292 7.92-7.919c.412-.422 1.036-.422 1.467 0 .413.422.413 1.046 0 1.459l-7.928 7.928-1.31 1.186 1.258-.088zm10.529 3.99.053-2.892.087-1.248-1.186 1.301-7.919 7.928c-.422.413-1.046.422-1.468 0-.413-.422-.413-1.046 0-1.46l7.928-7.927 1.292-1.186-1.222.088-2.9.061a.98.98 0 0 1-.712-.299c-.43-.43-.43-1.02 0-1.459.184-.175.475-.299.756-.299l6.337-.079c.624-.008 1.09.466 1.08 1.09l-.078 6.337c0 .273-.115.563-.3.756-.43.422-1.027.422-1.45 0a.94.94 0 0 1-.298-.712'
      />
    </mask>
    <g mask='url(#arrow-down-left-arrow-up-right_svg__a)'>
      <path fill={props.color} d='M0 0h24v24H0z' />
    </g>
  </svg>
)
const ForwardRef = forwardRef(SvgArrowDownLeftArrowUpRight)
export default ForwardRef
